import { create } from "zustand"

// Estado de la "Llave Doble" del lado cliente.
// 4 fases: idle → reaching → sealing → sealed → idle.

export type LinkPhase = "idle" | "reaching" | "sealing" | "sealed"

interface LinkState {
    phase: LinkPhase
    // A quién estoy pineando (cursor sostenido).
    myReachTarget: string | null
    // Quién está pineando hacia mí (puede ser varios — visual del haz cyan).
    incomingReaches: Set<string>
    // Mi par actual (durante sealing y sealed).
    peerId: string | null
    // Cuándo arrancó la cuenta de 3s (para animar el anillo).
    sealStartTs: number | null
    // Sello completado: yo soy el iniciador WebRTC?
    isInitiator: boolean

    setReaching: (target: string | null) => void
    addIncoming: (from: string) => void
    removeIncoming: (from: string) => void
    startSealing: (peerId: string) => void
    sealCompleted: (peerId: string, isInitiator: boolean) => void
    abort: () => void
}

const INITIAL = {
    phase: "idle" as LinkPhase,
    myReachTarget: null,
    incomingReaches: new Set<string>(),
    peerId: null,
    sealStartTs: null,
    isInitiator: false,
}

export const useLinkStore = create<LinkState>((set) => ({
    ...INITIAL,

    setReaching: (target) =>
        set({
            myReachTarget: target,
            phase: target ? "reaching" : "idle",
        }),

    addIncoming: (from) =>
        set((s) => {
            if (s.incomingReaches.has(from)) return s
            const next = new Set(s.incomingReaches)
            next.add(from)
            return { incomingReaches: next }
        }),

    removeIncoming: (from) =>
        set((s) => {
            if (!s.incomingReaches.has(from)) return s
            const next = new Set(s.incomingReaches)
            next.delete(from)
            return { incomingReaches: next }
        }),

    startSealing: (peerId) =>
        set({
            phase: "sealing",
            peerId,
            sealStartTs: Date.now(),
        }),

    sealCompleted: (peerId, isInitiator) =>
        set({
            phase: "sealed",
            peerId,
            isInitiator,
            sealStartTs: null,
        }),

    abort: () => set({ ...INITIAL, incomingReaches: new Set() }),
}))
